import { domain } from 'modules/data';
import moment from 'moment';

export const getNetSuiteCustomFieldValue = (field: domain.NetSuiteCustomField, shouldFormatDate = false) => {
    if (field.fieldType === 'TimeOfDay') {
        return moment.utc(field.valueDate).format('HH:mm:ss');
    }

    if (field.fieldType === 'Date') {
        return moment.utc(field.valueDate).format('ll');
    }

    if (field.fieldType === 'Datetime') {
        return moment.utc(field.valueDate).format('lll');
    }

    if (typeof field.valueBoolean === 'boolean') {
        return field.valueBoolean;
    }

    if (typeof field.valueDate === 'string') {
        return shouldFormatDate ? moment.utc(field.valueDate).format('ll') : field.valueDate;
    }

    if (typeof field.valueDecimal === 'number') {
        return field.fieldType === 'Percent' ? `${field.valueDecimal.toString()}%` : field.valueDecimal.toString();
    }

    if (typeof field.valueLong === 'number') {
        return field.valueLong.toString();
    }

    if (field.valueRef !== null) {
        return field.valueRef?.text;
    }

    if (Array.isArray(field.valueRefs)) {
        return field.valueRefs.map((ref) => ref.text).join('\n');
    }

    return field.valueString || null;
};
